<template>
  <div>
    <h4>{{ data.title }}</h4>

    <div class="mb-4" v-if="data.description">
      <h6 class="my-3">Вопрос:</h6>
      <quill-editor
        v-model="data.description"
        :options="editorOption"
        @focus="focus($event)"
      />
    </div>

    <div v-if="data.answers.length">
      <h6 class="my-2">Ответы:</h6>
      <ul>
        <li v-for="(answer, k) in data.answers" :key="k">
          <div :class="`questions-test ${answer.is_true ? 'true' : ''}`">
            <div v-if="answer['img']" class="questions-test-img">
              <img :src="answer['img']" />
            </div>
            <div class="questions-test-title">
              <h6 >{{ answer["title"] }}</h6>
              <span  class="badge badge-success">Правильный порядок: {{ answer["position"] + 1 }}</span>
            
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
  
  <script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
export default {
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: [],
        },
        readOnly: true,
        theme: "snow",
      },
    };
  },
  props: ["data"],
  components: {
    quillEditor,
  },
  methods: {
    focus(event) {
      event.enable(false);
    },
  },
};
</script>